import { ApolloLink, InMemoryCache } from '@apollo/client/core';
import { inject } from '@angular/core';
import { HttpLink } from 'apollo-angular/http';
import { environment } from '../../../environments/environment';

export const createApollo = (): { link: ApolloLink; cache: InMemoryCache } => {
  const httpLink = inject(HttpLink).create({ uri: environment.graphql_url });

  const middleware = new ApolloLink((operation, forward) => {
    return forward(operation);
  });

  const link = middleware.concat(httpLink);

  return {
    link,
    cache: new InMemoryCache(),
  };
};
